// angular
// 	.module("HeroPRO")
// 	.directive("hpPasswordInput", PasswordInput);

export default function PasswordInput() {
    return {
        restrict: 'E',
        controller: 'PasswordController',
        controllerAs: 'password',
        bindToController: true,
        templateUrl: 'app/common/controls/password/passwordTemplate.html',
        scope: {
            value: '@',
            passwordId: '@?',
            passwordName: '@?',
            isLabelVisible: '@',
            passwordLabel: '@?',
            errorDisplayCondition: '@?',
            onBlur: '&?',
        },
    // ,link: link
    };

    // function link(scope, element, attr, ctrl) {

    // }
}




// WEBPACK FOOTER //
// ./src/app/common/controls/password/passwordDirective.js